module.exports = __webpack_public_path__ + "img/k.3bc27fa8.png";